import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const siteHumanReadable = get(siteConf, '[og:site_name]');
  const searchQuery =
    get(state, 'search.data.query.queryString') ||
    get(state, 'search.queryString') ||
    '';
  const description = searchQuery
    ? `Search results for: ${searchQuery}`
    : `Search results on ${siteHumanReadable}`;
  const title = searchQuery
    ? `Search results for: ${searchQuery}`
    : `Search results on ${siteHumanReadable}`;

  const data = baseSeoUtil({
    site,
    siteConf,
    title,
    url: `https://www.${site}.com/search/${searchQuery}`,
    description,
    articleSection: searchQuery,
    config: state.config
  });

  // Add meta tag telling bots not to index this page
  data.meta.push({ name: 'robots', content: 'noindex' });

  return data;
}
